import * as React from "react";
import FilterList from '@mui/icons-material/FilterList';
import MuiRegularButton, { MuiRegularButtonProps } from "components/MuiExtras/Button/MuiRegularButton";
import { useTranslation } from 'react-i18next';

const CardButtonFilter: React.FC<MuiRegularButtonProps> = (props) => {
    const { title, ...rest } = props;
    const { t } = useTranslation();
    return (
        <MuiRegularButton
            {...rest}
            style={{ fontSize: "inherit" }}
            title={title || t("Common.Buttons.FilterText")}
        >
            <FilterList />
        </MuiRegularButton>
    );
};

CardButtonFilter.defaultProps = {
    color: "inherit",
    simple: true

};
export default CardButtonFilter;
